module.exports = __webpack_public_path__ + "assets/img/component_emit.57295405.jpg";